import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export function removeIntegrationFromSite(id: string): Promise<IResult> {
    const config: RestApiRequestConfig<{}, {}> = {
        restApiVersion: '-',
        httpMethod: 'DELETE',
        endpoint: `integrations/siteIntegrations/${id}`,
        serverWideRequest: true,
        requestBody: {},
    };

    return makeRestApiRequest<{}, IResult, {}>(config);
}